import React, { Suspense } from 'react';
import * as Sentry from "@sentry/react";
import { BrowserRouter } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { HelmetProvider } from 'react-helmet-async';
import { store } from 'store/store';
import Loading from 'shared/components/Loading';
import App from './App';
import 'shared/helpers/i18n';

Sentry.init({
  dsn: "https://febc1c616e440c0993ee68b72d167019@o4511113058451456.ingest.de.sentry.io/4511113121103952",
  enabled: import.meta.env.PROD,
  environment: import.meta.env.MODE,
  sendDefaultPii: false,
  tracesSampleRate: 0.1,
});

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <Sentry.ErrorBoundary>
    <Provider store={store}>
      <BrowserRouter>
        <HelmetProvider>
          <Suspense fallback={<Loading />}>
            <App />
          </Suspense>
        </HelmetProvider>
      </BrowserRouter>
    </Provider>
  </Sentry.ErrorBoundary>
);
